const isIframe = (node) => node.nodeName === "IFRAME";
const isSafe = (node, hosts) => {
  const src = node.getAttribute("src") || "";
  try {
    const { host } = new URL(src);
    return hosts.includes(host);
  } catch {
    return false;
  }
};
const removeUnsafeIframes = (hosts) => (node) => {
  if (isIframe(node) && !isSafe(node, hosts)) {
    node.remove();
  }
  return node;
};

export { removeUnsafeIframes };
//# sourceMappingURL=iframes.esm.js.map
